import { FileSelectField } from '@/components/custom/erp';
import { FormMode } from '@/types/form';

interface OtherTabProps {
  formMode: FormMode;
}

export default function OtherTab({ formMode }: OtherTabProps) {
  return (
    <div className='px-4'>
      <div className='flex flex-col justify-between lg:flex-row'>
        {/* Left column */}
        <div className='w-full space-y-2'>
          <div className='w-full max-w-md'>
            <FileSelectField
              label='Chọn files'
              formMode={formMode}
              labelClassName='w-28'
              onFileChange={file => console.log(file)}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
